import React, { useContext, useState, useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import FlexButton from "../../../components/FlexButton";
import { gradientColor } from "../../../contants";
import { useNavigate } from "react-router";
import { AuthContext } from "../../../context/auth";
import ThemeContext from "../../../context/themeContext";

const BannerContainer = styled(Box)(({ theme }) => ({
  paddingTop: "100px",
  Height: "400px",
  [theme.breakpoints.down("md")]: {
    paddingTop: "120px !important", // Padding for screen sizes equal to or wider than 'md'
  },
  [theme.breakpoints.down("sm")]: {
    paddingTop: "40px ", // Padding for screen sizes equal to or wider than 'sm'
  },
  [theme.breakpoints.down("xs")]: {
    paddingTop: "50px ", // Padding for screen sizes equal to or wider than 'md'
  },
}));

const dynamicData = [
  { text: "Liquidity" },
  { text: "Bitcoin Exchange" },
  { text: "Crypto Banking" },
];

export default function Banner() {
  const navigate = useNavigate();
  const [dataIndex, setDataIndex] = useState(0);
  const themeSettings = useContext(ThemeContext);
  const { userLoggedIn } = useContext(AuthContext);
  const isDark = themeSettings.settings.theme === "DARK" ? true : false;

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDataIndex((prevIndex) => (prevIndex + 1) % dynamicData.length);
    }, 2000);

    return () => clearInterval(intervalId);
  }, []);

  const currentData = dynamicData[dataIndex];

  return (
    <BannerContainer className="mainContainer">
      <Grid container spacing={3} alignItems="center">
        <Grid item lg={7} sm={12} md={7} xs={12}>
          <Typography variant="h1">
            Tarality = <span style={gradientColor}>{currentData.text}</span>
          </Typography>
          <Typography variant="h4" mt={1}>
            Your gateway to seamless, secure, and innovative trading
            experiences.
          </Typography>
          {!userLoggedIn && (
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{ marginTop: "10px" }}
            >
              <Grid
                item
                lg={5}
                md={5}
                sm={6}
                xs={6}
                // p={5}
                className="displayCenter"
              >
                <FlexButton
                  color="primary"
                  title="Sign Up Now"
                  fullWidth={true}
                  onClick={() => navigate(`/signup`)}
                  sx={{ padding: { xs: "4px", lg: "10px" } }}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item lg={5} sm={12} md={5} xs={12} alignItems={"center"}>
          {isDark ? (
            <Box className="displayCenter">
              <img
                src="/assets/images/whitebanner.png"
                alt="rgt_img"
                width="100%"
                style={{ maxWidth: "550px" }}
              />
            </Box>
          ) : (
            <Box className="displayCenter">
              <img
                src="/assets/images/darkbanner.png"
                alt="rgt_img"
                width="100%"
                style={{ maxWidth: "550px" }}
              />
            </Box>
          )}
        </Grid>
      </Grid>
    </BannerContainer>
  );
}
